if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      this.onClickRefreshList = this.onClickRefreshList.bind(this);
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initializeAvailability(), { once: true });
      } else {
        this.initializeAvailability();
      }
    }

    initializeAvailability() {
      const selectedVariantId = new URL(window.location.href).searchParams.get('variant');
      if (selectedVariantId && selectedVariantId !== this.dataset.variantId) {
        this.clearAvailability();
        return;
      }
      if (this.hasAttribute('available')) {
        this.fetchAvailability(this.dataset.variantId);
      } else {
        this.clearAvailability();
      }

    }

    clearAvailability() {
      this.requestId = (this.requestId || 0) + 1;
      this.innerHTML = '';
      this.removeAttribute('available');
      const drawer = document.getElementById('Pickup-Availability');
      if (drawer) {
        const wasActive = drawer.classList.contains('active');
        drawer.classList.remove('active');
        drawer.innerHTML = '';
        if (wasActive) document.body.classList.remove('open-cc');
      }
    }

    fetchAvailability(variantId) {
      this.clearAvailability();
      const requestId = this.requestId;
      this.dataset.variantId = String(variantId);
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          if (requestId !== this.requestId) return;
          const selectedVariantId = this.closest('.thb-product-detail')?.querySelector('product-form input[name="id"]')?.value;
          if (selectedVariantId && String(variantId) !== String(selectedVariantId)) {
            this.clearAvailability();
            return;
          }
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);

        })
        .catch(e => {
          if (requestId !== this.requestId) return;
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = '';

			if ( this.querySelector('button') ) {
	      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
			}
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('.pickup-availability-drawer');
      if (drawer) drawer.remove();
      if (!sectionInnerHTML?.querySelector('.pickup-availability-information')) {
        this.clearAvailability();
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-information').innerHTML;
      this.setAttribute('available', '');

      document.getElementById('Pickup-Availability').innerHTML = sectionInnerHTML.querySelector('.side-availability').innerHTML;

      const button = this.querySelector('button');
      if (button) button.addEventListener('click', (evt) => {
        document.getElementById('Pickup-Availability').classList.toggle("active");
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');

        evt.preventDefault();
      });
    }
  });
}
